import { render } from "./FinanceControls.vue?vue&type=template&id=37be0ace&scoped=true"
import script from "./FinanceControls.vue?vue&type=script&lang=js"
export * from "./FinanceControls.vue?vue&type=script&lang=js"

import "./FinanceControls.vue?vue&type=style&index=0&id=37be0ace&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37be0ace"]])

export default __exports__